import { refreshAdjustablePanel } from './sceneSubjects/AdjustableCharacter';
import { buildHandPoseMenu, buildMenus, buildPoseMenu, buildPropsMenu, buildSceneMenu } from './helpers/Menus';

class Store {
    constructor() {
        this.state = {
            savedPoses: {},
            savedScenes: {},
            savedBodyTypes: [],
            poseLibrary: {},
            propPacks: [],
            user: {},
        };
    }

    setState(newState) {
        if (newState.savedPoses) {
            this.state.savedPoses = newState.savedPoses;
            buildPoseMenu()
        } else if (newState.savedScenes) {
            this.state.savedScenes = newState.savedScenes;
            buildSceneMenu()
        } else if (newState.savedBodyTypes) {
            this.state.savedBodyTypes = newState.savedBodyTypes;
            refreshAdjustablePanel()
        } else if (newState.poseLibrary) {
            this.state.poseLibrary = newState.poseLibrary;
            buildPoseMenu()
            buildHandPoseMenu()
        } else if (newState.user) {
            this.state.user = newState.user;
            buildMenus()
        } else if (newState.propPacks) {
            this.state.propPacks = newState.propPacks;
            buildPropsMenu()
        } else {
            buildMenus()
        }

        // console.log("[State updated]:", this.state);
    }
}

export default Store;